import type { ReactNode } from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { useTenantBlocked } from '@/settings/hooks';

// M5.7 — обёртка для мутирующей кнопки. При блокировке оптики показывает
// tooltip «Недоступно — работа приостановлена». Сама кнопка должна получить
// disabled (обычно `disabled={isBlocked || ...}`); span-обёртка ловит hover
// поверх disabled-кнопки — у AntD Button при disabled стоит
// pointer-events:none, поэтому события «проваливаются» на родительский span.
export function BlockedActionTooltip({ children }: { children: ReactNode }): JSX.Element {
  const { t } = useTranslation();
  const { isBlocked } = useTenantBlocked();

  if (!isBlocked) return <>{children}</>;

  return (
    <Tooltip title={t('blocked.tooltip')}>
      <span style={{ cursor: 'not-allowed', display: 'inline-flex' }}>{children}</span>
    </Tooltip>
  );
}
